import React, { useState } from "react";

export const AppContext = React.createContext(null);

const initStore = {
  tooltipData: {
    townName: "",
    likes: "",
    insert: "",
  },

  modalVisible: false,
};

const StoreWrapper = ({ children }) => {
  const [store, setStore] = useState(initStore);
  const [actions, setActions] = useState({
    setTooltipData: (data) => {
      setStore({
        ...store,
        tooltipData: { ...store.tooltipData, ...data },
      });
    },

    setPrizeModalVisible: () => {
      setStore({
        ...store,
        modalVisible: true,
      });
    },
    setPrizeModalHide: () => {
      setStore({
        ...store,
        modalVisible: false,
      });
    },
  });

  return (
    <AppContext.Provider value={{ store, actions }}>
      {children}
    </AppContext.Provider>
  );
};

export default StoreWrapper;
